module.exports = __webpack_public_path__ + "img/case_pdjc.1ea78f74.jpg";